<template src="./index.html"></template>

<script>
import { getYear, getCACodeDesc, inquiryKmzz } from '../../../../api/home.js';
import { getdata } from './data.js';
import config from '../../../../../configHttp';
export default {
	data() {
		return {
			/* 表格 */
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			headData: getdata().headData,
			tableData: [],
			tablekey: 0,
			/* 表格 */
			id: ''
		};
	},
	mounted() {},
	activated() {
		this.InitializeJiem();
	},
	created() {
		this.id = this.$route.query.id;
		this.searchdata.zhongfkm = this.$route.query.zhongfkm;
		this.searchdata.cain = this.$route.query.cain;
		this.InitializeJiem();
	},
	methods: {
		//跳转到明细账页面
		toSubLedgerTable(scope) {
			this.$router.push({
				path: '/SubLedgerTable',
				query: {
					id: this.id,
					zhongfkm: this.searchdata.zhongfkm,
					cain: this.searchdata.cain,
					qij: scope.taxval.qij
				}
			});

		},
		//查询
		submitSearch() {
			let params = {};
			params.criteriaJson = JSON.stringify(this.searchdata);
			inquiryKmzz(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
				}
			});
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},

		InitializeJiem() {
			this.searchlist = getdata().searchlist;
			//获取财年
			getYear().then(res => {
				for (var i = res.data.data.max; i >= res.data.data.min; i--) {
					this.searchlist[1].selectval.push({
						label: i,
						value: i
					});
				}
				//获取中方科目 下拉
				let params = {};
				params.likeSearch = '';
				params.isLastLevel = false;
				getCACodeDesc(params).then(res1 => {
					this.searchlist[0].selectval = res1.data.data.map(v => {
						return {
							value: v.key,
							label: v.key+"-"+v.value
						};
					});
					params = {};
					params.criteriaJson = JSON.stringify(this.searchdata);
					inquiryKmzz(params).then(res2 => {
						if (res2.data.code == '200') {
							this.tableData = res2.data.data;
							this.searchlist = JSON.parse(JSON.stringify(this.searchlist));
						}
					});
				});
			});
		},
		forback() {
			this.$router.push({
				path: '/PreviewVoucher',
				query: {
					id: this.id
				}
			});
		},
		//下载总账PDF
		PDFDownload(){
			let params = {};
			params.cain = this.searchdata.cain;
			params.zhongfkmStart = this.searchdata.zhongfkm;
			params.zhongfkmEnd = this.searchdata.zhongfkm;
			params.baoblx = ["0"];
			let req = {
				downUrl: config.baseURL + '/fvm/voucher/glPDFDownload',
				params: params,
				typeObj: {
					toForm: false,
					fileType: 'pdf',
					fileName: this.searchdata.zhongfkm + "-" + this.searchdata.cain
				}
			};
			this.$downloadcommon(req);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
